(function($, root) {

  $.getParams = function() {

    if (document.location.toString().indexOf('?') !== -1) {
      var query = document.location
        .toString()
        // get the query string
        .replace(/^.*?\?/, '')
        // and remove any existing hash string (thanks, @vrijdenker)
        .replace(/#.*$/, '')
        .split('&');

      for (var i = 0, l = query.length; i < l; i++) {
        var aux = decodeURIComponent(query[i]).split('=');
        window.rdo.get[aux[0]] = aux[1];
      }
    }
  }

  $.constructPage = function() {

    $.getCurrentPath();
    // $.renderIntro();

    //after the page data is loaded:
    $.loadPageData().done(function() {
          $(window).checkScreen();
      if (!window.rdo.isMobile || window.rdo.page.orientation != 'smartphone') {
        $.startPage();
      }
    });

    // }

    // else if (window.location.pathname.indexOf(window.rdo.pages.questionnaire) >= 0) {
    //   // $.initQuestionnaireAnswers();
    //
    // } else if (window.location.pathname.indexOf(window.rdo.pages.character) >= 0 || window.location.pathname.indexOf(window.rdo.pages.singlecharacter) >= 0) {
    //
    // }

  }

})(jQuery, this);
